module.exports = __webpack_public_path__ + "img/pds_config_2.b101cf62.svg";